import { classSet, Panel } from '@platform/ui-library';
import { FC, useState } from 'react';
import { scriptKeys } from '@app/const';
import { CodeEditor } from '@app/form_components';
import { ChangesetReason } from '../../../../types';
import { useConflictsContext } from '../hooks';
import {
  ConflictResolution,
  DesignConflictItem
} from '../types';
import styles from './design-conflict-item-container.module.scss';

export interface DesignConflictItemContainerProps {
  item: DesignConflictItem;
}

export const DesignConflictItemContainer: FC<(
  DesignConflictItemContainerProps
)> = ({
  item
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const {
    setResolution,
    sourceLabel,
    targetLabel
  } = useConflictsContext();
  const {
    changes,
    icon,
    key,
    label,
    resolution,
    source
  } = item;
  const isResolved = resolution !== ConflictResolution.none;

  const header = (
    <div>
      {(!icon) ? null : (
        <i className={classSet([`fe icon-${icon}`, styles.itemIcon])} />
      )}
      <span className={styles.itemName}>
        {label}
      </span>
      <span className={styles.itemReason}>
        {(source.reason === ChangesetReason.added) ? (
          // If there is a conflict, then the add is actually a modification.
          ChangesetReason.modified
        ) : source.reason}
      </span>
    </div>
  );

  return (
    <div data-is-resolved={isResolved}>
      <Panel
        className={styles.conflictWrapper}
        header={header}
        isOpen={isOpen}
        onIsOpenToggle={setIsOpen}
      >
        <table>
          <thead>
            <tr className={styles.versionsHeader}>
              <th scope="row">Version</th>
              <td>
                <span>
                  <input
                    checked={resolution === ConflictResolution.target}
                    id={`${key}-${ConflictResolution.target}`}
                    name={key}
                    onChange={() => setResolution(key, ConflictResolution.target)}
                    type="radio"
                  />
                  <label htmlFor={`${key}-${ConflictResolution.target}`}>
                    {targetLabel}
                  </label>
                </span>
              </td>
              <td>
                <span>
                  <input
                    checked={resolution === ConflictResolution.source}
                    id={`${key}-${ConflictResolution.source}`}
                    name={key}
                    onChange={() => setResolution(key, ConflictResolution.source)}
                    type="radio"
                  />
                  <label htmlFor={`${key}-${ConflictResolution.source}`}>
                    {sourceLabel}
                  </label>
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            {changes.map(({
              id,
              label,
              source,
              target
            }) => {
              return (
                <tr className={styles.properties} key={id}>
                  <th>{label}</th>
                  {(scriptKeys.has(id)) ? (
                    <td colSpan={2} style={{ height: '20vh' }}>
                      {(!isOpen) ? null : (
                        <CodeEditor
                          originalValue={target}
                          readOnly
                          value={source}
                        />
                      )}
                    </td>
                  ) : (
                    <>
                      <td>{target}</td>
                      <td>{source}</td>
                    </>
                  )}
                </tr>
              );
            })}
            <tr className={styles.whos}>
              <td></td>
              <td>Current</td>
              <td>Incoming</td>
            </tr>
          </tbody>
        </table>
      </Panel>
    </div>
  );
};
